// Pepperdine's undergraduate majors (#2840). Read on 2026-10-01 from the
// official Seaver College Academic Catalog 2026-2027 (PDF, linked from
// seaver.pepperdine.edu/academics/catalog/), whose division openers list
// "The Bachelor of Arts Degree Is Offered with Majors in the Following" and
// the same for the Bachelor of Science; every bachelor's major there is
// kept, grouped by division, with the degree the catalog names (full names;
// the catalog does not abbreviate them). Minors, teaching credentials,
// certificates and graduate degrees are left out. Nursing (BSN) is not in
// the Seaver catalog's division lists: the catalog says the College of
// Health Science's School of Nursing offers "a bachelor of science (BSN)",
// and Seaver's Majors and Minors page lists Nursing, so it is its own group
// citing the BSN page. Quirk: Seaver's Majors and Minors web page lists
// "Psychology", "Computer Science/Mathematics" and "Computer
// Science/Philosophy"; the 2026-2027 catalog names "Psychological Science"
// and "Computer Science", which are used. The KB's majors list was the
// starting point; the catalog wins.
const majors = {
    "slug": "pepperdine-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in Pepperdine's official 2026-2027 Seaver College Academic Catalog, grouped by the division that offers it, plus the Nursing BSN from the College of Health Science. Minors, credentials, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "Business Administration Division",
            "source": {
                "label": "Seaver College Academic Catalog 2026-2027",
                "url": "https://seaver.pepperdine.edu/academics/content/seaver-catalog-2026-2027.pdf"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Business Administration",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Finance",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "International Business",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "Communication Division",
            "source": {
                "label": "Seaver College Academic Catalog 2026-2027",
                "url": "https://seaver.pepperdine.edu/academics/content/seaver-catalog-2026-2027.pdf"
            },
            "majors": [
                {
                    "name": "Advertising",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Communication Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Integrated Marketing Communication",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Journalism",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Public Relations",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Screen Arts",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Sport Administration",
                    "degree": "Bachelor of Arts"
                }
            ]
        },
        {
            "name": "Fine Arts Division",
            "source": {
                "label": "Seaver College Academic Catalog 2026-2027",
                "url": "https://seaver.pepperdine.edu/academics/content/seaver-catalog-2026-2027.pdf"
            },
            "majors": [
                {
                    "name": "Art",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Art History",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Design",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Music",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Theatre Arts",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Theatre and Screen Arts",
                    "degree": "Bachelor of Arts"
                }
            ]
        },
        {
            "name": "Humanities and Teacher Education Division",
            "source": {
                "label": "Seaver College Academic Catalog 2026-2027",
                "url": "https://seaver.pepperdine.edu/academics/content/seaver-catalog-2026-2027.pdf"
            },
            "majors": [
                {
                    "name": "Creative Writing",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "English",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Film",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "History",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Liberal Studies for Education",
                    "degree": "Bachelor of Arts"
                }
            ]
        },
        {
            "name": "International Studies and Languages Division",
            "source": {
                "label": "Seaver College Academic Catalog 2026-2027",
                "url": "https://seaver.pepperdine.edu/academics/content/seaver-catalog-2026-2027.pdf"
            },
            "majors": [
                {
                    "name": "French Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Hispanic Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "International Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Italian Studies",
                    "degree": "Bachelor of Arts"
                }
            ]
        },
        {
            "name": "Natural Science Division",
            "source": {
                "label": "Seaver College Academic Catalog 2026-2027",
                "url": "https://seaver.pepperdine.edu/academics/content/seaver-catalog-2026-2027.pdf"
            },
            "majors": [
                {
                    "name": "Biology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Biology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Chemistry",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Chemistry",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Computer Science",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Data Science",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Mathematics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Mathematics Education",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Natural Science",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Nutritional Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Physics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Sports Medicine",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Sports Medicine",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "Religion and Philosophy Division",
            "source": {
                "label": "Seaver College Academic Catalog 2026-2027",
                "url": "https://seaver.pepperdine.edu/academics/content/seaver-catalog-2026-2027.pdf"
            },
            "majors": [
                {
                    "name": "Philosophy",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Religion",
                    "degree": "Bachelor of Arts"
                }
            ]
        },
        {
            "name": "Social Science Division",
            "source": {
                "label": "Seaver College Academic Catalog 2026-2027",
                "url": "https://seaver.pepperdine.edu/academics/content/seaver-catalog-2026-2027.pdf"
            },
            "majors": [
                {
                    "name": "Economics",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Political Science",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Psychological Science",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Sociology",
                    "degree": "Bachelor of Arts"
                }
            ]
        },
        {
            "name": "Interdisciplinary Programs",
            "source": {
                "label": "Seaver College Academic Catalog 2026-2027",
                "url": "https://seaver.pepperdine.edu/academics/content/seaver-catalog-2026-2027.pdf"
            },
            "majors": [
                {
                    "name": "Sustainability",
                    "degree": "Bachelor of Arts"
                }
            ]
        },
        {
            "name": "College of Health Science, School of Nursing",
            "source": {
                "label": "Pepperdine College of Health Science, Bachelor of Science in Nursing",
                "url": "https://healthscience.pepperdine.edu/bsn/"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "BSN"
                }
            ]
        }
    ]
};

export default majors;
